<script>
  import { ignore } from '../../../Common/tools';
  import { External, M } from '../../../external';
  import { onDestroy, onMount } from 'svelte';

  export let data = {};
  export let onChange = ignore;

  const EMAIL_TYPES = [
    { id: 0, text: M.CAMPAIGN },
    { id: 1, text: M.AUTOMATION }
  ];

  let settings, campaigns, automations;

  function makeRequest(action, id) {
    return new Promise((resolve, reject) => {
      let params = {
        action: action,
        onOk: (resp) => {
          if (resp.data?.length) {
            resolve(resp.data);
          } else {
            reject();
          }
        }
      };
      if (id) {
        params.data = {
          id: id
        };
      }
      External.Tools.makeWebsiteRequest(params);
    });
  }

  async function getCampaigns() {
    if (!campaigns) {                                                                     //fetch, then cache
      campaigns = await makeRequest('getEmailCampaignNames').catch(() => {
        External.Tools.showError(M.NO_CAMPAIGNS_YET);
        settings.emailType = '0';
      });
    }
    return campaigns;
  }

  async function getAutomations() {
    if (!automations) {
      automations = await makeRequest('getAutomationNames').catch(() => {
        External.Tools.showError(M.NO_AUTOMATIONS_YET);
        settings.emailType = '0';
      });
    }
    return automations;
  }

  async function getEmailSteps(index) {
    if (!automations[index].emails) {
      automations[index].emails = await makeRequest('getEmailSteps', automations[index].id).catch(() => {
        External.Tools.showError(M.NO_AUTOMATION_EMAILS);
        settings.automationId = '0';
        settings.stepId = '0';
      });
      if(automations[index].emails) {
        automations[index].emails.forEach(step => {
          step.name = step.name.replaceAll('"', '');
        });
      }
    }
    return automations[index].emails;
  }

  async function selectEmailType() {
    if (settings.emailType === EMAIL_TYPES[0].id) {
      settings.campaigns = await getCampaigns();
      settings.automationId = '0';
      settings.stepId = '0';
      settings.emails = null;
    } else if (settings.emailType === EMAIL_TYPES[1].id) {
      settings.automations = await getAutomations();
      if (settings.automations) {
        await selectAutomation(true);
      }
      settings.campaignId = '0';
    }
  }

  async function selectAutomation(init) {
    let index = automations.findIndex((auto) => {
      return auto.id === settings.automationId;
    });
    if (index > -1) {
      settings.emails = await getEmailSteps(index);
    }
    if (!init) {
      settings.stepId = '0';
    }
  }

  $: if (settings && settings.loaded && (settings.campaignId !== '0' || settings.stepId !== '0')) {   //only save when a campaign or step is selected
    data.settings[0] = {
      key: '0',
      value: JSON.stringify({
        emailType: settings.emailType,
        campaignId: settings.campaignId,
        automationId: settings.automationId,
        stepId: settings.stepId
      })
    };

    onChange();
  }

  onMount(async () => {
    if (!data.settings) {
      data.settings = [];
    }

    settings = data.settings[0] ? JSON.parse(data.settings[0].value) :
      {
        emailType: '0', //string needed to bind to the "please select" option val
        campaignId: '0',
        automationId: '0',
        stepId: '0'
      };

    await selectEmailType();

    settings.loaded = true;
  });

  onDestroy(() => {
    settings = campaigns = automations = null;
  });

</script>

{#if settings && settings.loaded}
  <div class='col20 f-left small-rules mb-25'>
    <h4 class='col20 f-left mt-15 mb-10 t-center' style='line-height:1.4;'>{M.WHEN_USER_OPENS_EMAIL}</h4>
    <div class='popup-input-wrapper f-left mt-25'>
      <div class='info'>
        <h5>{M.SELECT_EMAIL_TYPE}</h5>
      </div>
      <select class='page-select' bind:value={settings.emailType} on:change={async () => {await selectEmailType()}}>
        <option value='0' disabled>{M.PLEASE_SELECT}</option>
        {#each EMAIL_TYPES as type}
          <option value='{type.id}'>{type.text}</option>
        {/each}
      </select>
    </div>
    {#if settings.emailType === EMAIL_TYPES[0].id}
      {#if settings.campaigns && settings.campaigns.length}
        <div class='popup-input-wrapper f-left'>
          <div class='info'>
            <h5>{M.SELECT_A_CAMPAIGN}</h5>
          </div>
          <select class='page-select' bind:value={settings.campaignId}>
            <option value='0' disabled>{M.PLEASE_SELECT}</option>
            {#each campaigns as campaign}
              <option value='{campaign.id}'>{campaign.name}</option>
            {/each}
          </select>
        </div>
      {/if}
    {:else if settings.emailType === EMAIL_TYPES[1].id}
      {#if settings.automations && settings.automations.length}
        <div class='popup-input-wrapper f-left'>
          <div class='info'>
            <h5>{M.SELECT_AN_AUTOMATION}</h5>
          </div>
          <select class='page-select' bind:value={settings.automationId}
                  on:change={async () => {await selectAutomation()}}>
            <option value='0' disabled>{M.PLEASE_SELECT}</option>
            {#each settings.automations as auto}
              <option value='{auto.id}'>{auto.name}</option>
            {/each}
          </select>
        </div>
        <div class='popup-input-wrapper f-left'>
          {#if settings.emails && settings.emails.length}
            <div class='info'>
              <h5>{M.SELECT_AN_EMAIL}</h5>
            </div>
            <select class='page-select' bind:value={settings.stepId}>
              <option value='0' disabled>{M.PLEASE_SELECT}</option>
              {#each settings.emails as email}
                <option value='{email.id}'>{email.name}</option>
              {/each}
            </select>
          {/if}
        </div>
      {/if}
    {/if}
  </div>
{/if}
